<script setup>

/*
    @name kt-loading
    @date: 20240823
    @description: Small animated loading graphic. Can be used inline or fullscreen.
    @author: Jon Freynik

    <kt-loading
        :visible="false"
        :fullscreen="false"
        :wheelsize="'2rem'"
        :bgcolor="'rgba(0, 0, 0, 0.35)'"
        :wheelborder="'3px solid rgba(255, 255, 255, 1)'"
        :curveborder="'3px solid rgba(65, 151, 205, 1)'"
    ></kt-loading>

*/

const props = defineProps(
{
    visible:
    {
        type: Boolean,
        default: false
    }, 

    fullscreen: 
    {
        type: Boolean,
        default: false
    },

    wheelsize:
    {
        type: String,
        default: "1.5rem"
    },

    bgcolor: 
    {
        type: String,
        default: "rgba(0, 0, 0, 0.55)"
    },

    wheelborder: 
    {
        type: String,
        default: "3px solid rgba(255, 255, 255, 1)"
    },

    curveborder:
    {
        type: String,
        default: "3px solid rgba(65, 151, 205, 1)"
    }
});

</script>


<template>
<div v-if="props.visible" :class="['kt-loading-bg', { 'kt-loading-fullscreen': props.fullscreen }]">
    <div class="kt-loading-fg"></div>
</div>
</template>

<style scoped>

.kt-loading-bg {
    position: relative;
    display: inline-block;
    background-color: v-bind('props.bgcolor');
    padding: calc(v-bind('props.wheelsize') / 2)
}

.kt-loading-fullscreen {
    position: fixed;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999999;
}

.kt-loading-fg {
    width: v-bind('props.wheelsize');
    height: v-bind('props.wheelsize');
    border-radius: 255px;
    border: v-bind('props.wheelborder');
    border-top: v-bind('props.curveborder');
    animation: 3s spinning infinite;
}

.kt-loading-fullscreen .kt-loading-fg {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: calc(v-bind('props.wheelsize') / 2 * -1);
    margin-left: calc(v-bind('props.wheelsize') / 2 * -1);
}

@keyframes spinning {
    0% { rotate: 0deg }
    100% { rotate: 1080deg }
}

</style>